import { render, staticRenderFns } from "./Fecha.vue?vue&type=template&id=96d72d24"
import script from "./Fecha.vue?vue&type=script&lang=js"
export * from "./Fecha.vue?vue&type=script&lang=js"
import style0 from "./Fecha.vue?vue&type=style&index=0&id=96d72d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports